export default __webpack_public_path__ + "static/media/gallery - original vs translated_00.24b1f789.jpg";